import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-contact-link',
  templateUrl: './contact-link.component.html',
  styleUrls: ['./contact-link.component.scss']
})
export class ContactLinkComponent {

  @Input() type: string = '';
  @Input() value: string = '';
  @Input() label: string = '';

  getContactIcon(type: string) {

    switch (type) {
      case 'TELB':
      case 'MOBB':
        return 'phone';
      case 'MAILB':
        return 'social-email';
      case 'link':
      case 'HOMEPAGE':
        return 'link';
      case 'FACEBOOK':
        return 'social-facebook';
      case 'KARRIEREPORTAL':
        return 'link';
      case 'LINKEDIN':
        return 'social-linkedin';
      case 'XING':
        return 'link';
      case 'YOUTUBE':
        return 'social-youtube';
      case 'INSTAGRAM':
        return 'social-instagram';
      case 'X':
        return 'social-twitter';
      case 'TIKTOK':
        return 'social-tiktok';
      default:
        return 'link';
    }
  }

  getContactLink(type: string, value: string) {

    let prefix = "";

    switch (type) {
      case 'TELB':
      case 'MOBB':
        prefix = 'tel:';
        break;
      case 'MAILB':
        prefix = 'mailto:';
        break;
      case 'HOMEPAGE':
        if(this.value.indexOf("http") === -1) {
          prefix = 'http://';
        }
        break;
      default:
        break;
    }

    return prefix + value.replace(" ", "");
  }

  getLabel() {
    if(this.label.length) {
      return this.label;
    }

    switch (this.type) {
      case 'TELB':
      case 'MOBB':
        return 'Telefon';
      case 'MAILB':
        return 'E-Mail';
      case 'HOMEPAGE':
        return "Unsere Webseite";
      case 'FACEBOOK':
        return 'Facebook';
      case 'KARRIEREPORTAL':
        return 'Karriereportal';
      case 'LINKEDIN':
        return 'LinkedIn';
      case 'XING':
        return 'Xing';
      case 'YOUTUBE':
        return 'YouTube';
      case 'INSTAGRAM':
        return 'Instagram';
      case 'X':
        return 'X (Twitter)';
      case 'TIKTOK':
        return 'TikTok';
      default:
        return this.value;
    }

  }
}
